import {ROWS_PER_PAGE} from '../constants/rowsPerPage';

export function getPageAlignedDataOffset(dataLength: number): number {
  return Math.floor(dataLength / ROWS_PER_PAGE) * ROWS_PER_PAGE;
}
